// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".refresh[data-v-54c42e66]{color:#00afa1;cursor:pointer;text-decoration:underline}.refresh[data-v-54c42e66]:hover{text-decoration:none}.buttons[data-v-54c42e66]{display:-webkit-box;display:-ms-flexbox;display:flex}.buttons__item[data-v-54c42e66]{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:0 17px}.phone[data-v-54c42e66] .bim-input label{display:none}.agreement[data-v-54c42e66]{font-size:14px}.agreement a[data-v-54c42e66]{color:#00afa1}", ""]);
// Exports
module.exports = exports;
